import styled from 'styled-components'
import { theme } from '../../../styles/theme'

export const Container = styled.header`
  width: calc(100vw - 93px);
  height: 93px;
  padding: 0px 30px;
  margin-left: 93px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  position: absolute;
  z-index: 999;

  background: ${theme.colors.white};
  box-shadow: 0px 6px 15px rgba(37, 42, 49, 0.1);

  & > img {
    height: 60px;
  }
`

export const Profile = styled.div`
  position: relative;
`

export const ProfileWrapper = styled.button`
padding: 6px;

border-radius: 8px;

display: flex;
align-items: center;
gap: 16px;

position: relative;

background: none;
transition: background 0.2s;
&:hover {
  background: rgba(0,0,0,0.05);
}
`

export const PhotoWrapper = styled.div`
  width: 56px;
  height: 56px;

  border-radius:  56px;
  background: linear-gradient(98.6deg, #3C2E21 7.49%, #796C5F 98.19%);

  display: flex;
  align-items: center;
  justify-content: center;
`

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const Username = styled.p`
  margin: 0;

  font-size: ${theme.font.sizes.large};
  font-weight: ${theme.font.semiBold};
  font-family: ${theme.font.inter};
  color: ${theme.colors.gray900};
`

export const Role = styled.p`
  margin: 0;

  font-size: ${theme.font.sizes.medium};
  font-weight: ${theme.font.medium};
  font-family: ${theme.font.inter};
  color: #8D93A4;
`

export const ArrowWrapper = styled.div`
  & > svg > path {
    fill: ${theme.colors.black};
  }
`

export const Dropdown = styled.div`
  position: absolute;
  margin-top: 10px;

  left: 0;
  right: 0;
  bottom: -60px;

  background: ${theme.colors.gray300};
  border: 1px solid ${theme.colors.gray200};
  border-radius: 4px;

  & > button {
    padding: 16px;
    width: 100%;

    font-size: ${theme.font.sizes.normal};
    font-weight: ${theme.font.semiBold};
    font-family: ${theme.font.inter};
    color: ${theme.colors.black};
  }
`

export const Name = styled.h1`
  font-size: ${theme.font.sizes.large};
  font-weight: ${theme.font.semiBold};
  font-family: ${theme.font.inter};
  color: ${theme.colors.black};
`
